import { render, staticRenderFns } from "./lp-faculty-card.vue?vue&type=template&id=4b764556&"
import script from "./lp-faculty-card.vue?vue&type=script&lang=js&"
export * from "./lp-faculty-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports